import React, {useContext, useCallback} from 'react';

import ActivityButton from '~/src/components/activity/button/ActivityButton';
import ThumbsUpDown from '~/src/components/svg/action/ThumbsUpDown';

import {getContentUrl} from '~/src/utilities/helpers/link';
import {Hashes} from '~/src/utilities/constants/hash.js';
import {SitemapContext} from '~/src/components/context/SitemapContext';
import {pushRoute} from '~/src/utilities/helpers/router.js';
import {trackGtm} from '~/src/utilities/tracking/gtm';
import {GtmEvents} from '~/src/utilities/constants/tracking';
import initPolyglot from '~/src/utilities/libs/polyglot';

import i18nStrings from './RatingButton.i18n.json';

const getTranslation = initPolyglot(i18nStrings);

const RatingButton = ({metadataId, format, colorScheme, source, activityCount, onClick}) => {
    const {all} = useContext(SitemapContext);

    const handleClick = useCallback((event) => {
        event.preventDefault();

        if (window.location.pathname.endsWith(metadataId)) {
            pushRoute(all, getContentUrl(window.location.pathname, Hashes.RATING_SECTION), true);
        } else {
            pushRoute(all, getContentUrl(metadataId.toString(), Hashes.RATING_SECTION));
        }

        trackGtm(GtmEvents.INTERACTION, {
            interactionType: 'rating',
            interactionSource: source,
            contentId: metadataId
        });

        onClick && onClick();
    }, []);

    return (
        <React.Fragment>
            <ActivityButton format={format} colorScheme={colorScheme} onClick={handleClick} activityCount={activityCount} data-testid="RatingButton">
                <ThumbsUpDown title={getTranslation('title')} />
            </ActivityButton>
        </React.Fragment>
    );
};

export default RatingButton;
